module.exports = __webpack_public_path__ + "static/media/grand-lounge-white.b2adf046.png";